import { CSSProperties } from "react";

export declare type EyeGlassProps = {
	style?: CSSProperties;
}

export const EyeGlass = ({
	style,
}: EyeGlassProps) => {

	const svgprops = Object.assign({},
		style ? { style, } : { }
	);

	return (
		<div className="icon">
			<svg viewBox="0 0 18 18" xmlns="http://www.w3.org/2000/svg" {...svgprops}>
				<path fillRule="evenodd" clipRule="evenodd" d="M1.29169 8.16699C1.29169 4.37003 4.36973 1.29199 8.16669 1.29199C11.9636 1.29199 15.0417 4.37003 15.0417 8.16699C15.0417 11.964 11.9636 15.042 8.16669 15.042C4.36973 15.042 1.29169 11.964 1.29169 8.16699ZM8.16669 0.0419922C3.67937 0.0419922 0.041687 3.67968 0.041687 8.16699C0.041687 12.6543 3.67937 16.292 8.16669 16.292C10.1854 16.292 12.0321 15.5558 13.4531 14.3373L16.0581 16.9423C16.3022 17.1863 16.6979 17.1863 16.942 16.9423C17.186 16.6982 17.186 16.3025 16.942 16.0584L14.337 13.4534C15.5555 12.0324 16.2917 10.1857 16.2917 8.16699C16.2917 3.67968 12.654 0.0419922 8.16669 0.0419922Z" />
			</svg>
		</div>
	);

}
